import { NgModule } from '@angular/core';
import { RouterModule, Routes } from "@angular/router";
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AnonComponent } from './anon.component';
import { BodyService, LocalStorageService, SessionStorageService } from '../../services';
import { CarouselModule } from '../../components/carusele/carousel.module';
import { CurveRangeModule } from '../../components/curve-range/curve-range.module';

import { LandingComponent } from './landing/landing.component';
import { ToolsComponent } from './components/tools/tools.component';
import { HelpCenterModule } from '../../components/help-center/help-center.module'
import { HelpComponent } from './help/help.component';
import { TranslateModule } from '@ngx-translate/core';
import { MatSelectModule } from '@angular/material/select';
import { MaterialModule } from '../../material/material.module';
import { ConsentComponent } from './components/consest/consent.component';
import { RegulationsModule } from '../../components/regulations/regulations.module';
import { TosComponent } from '../../components/regulations/tos/tos.component';
import { PrivacyComponent } from '../../components/regulations/privacy/privacy.component';
import { PlanService } from 'src/app/services/plan.service';  
import { PartnerPlanComponent } from './landing/components/partner-plan/partner-plan.component';
import { DefaultPlanComponent } from './landing/components/default-plan/default-plan.component';


const layoutAuthRoutes: Routes = [
{
    path: '',
    component: AnonComponent,
    children: [
        { path: '', component: LandingComponent, data: { title: 'Home' } },
        { path: 'tos', component: TosComponent, data: { title: 'Terms Of Service' } },
        { path: 'privacy', component: PrivacyComponent, data: { title: 'Privacy' } },
        { path: 'help', component: HelpComponent, data: { title: 'Help' } }
    ]
}];

const IMPORTS: any = [
    RouterModule.forChild(layoutAuthRoutes),
    CommonModule,
    FormsModule,
    CarouselModule,
    CurveRangeModule,
    HelpCenterModule,
    TranslateModule,
    MatSelectModule,
    MaterialModule,
    RegulationsModule
];

const COMPONENTS = [
    AnonComponent,
    HelpComponent,
    LandingComponent,
    ConsentComponent,
    DefaultPlanComponent,
    PartnerPlanComponent
];

@NgModule({
    declarations: COMPONENTS,
    imports: IMPORTS,
    providers: [BodyService, LocalStorageService, SessionStorageService, PlanService],
    exports: COMPONENTS
})
export class AnonModule { }
